import ChatbotFileList from "@/components/chatbot-file-list";
import ChatbotMessageContent from "@/components/chatbot-message-content";
import ChatbotReferenceBubbles from "@/components/chatbot-reference-bubbles";

export default function ChatbotMessage({ message, surface, latestRef = null, userLabel = "Dig" }) {
  const prefix = surface === "widget" ? "chatbot-widget" : "chatbot-fullscreen";

  return (
    <article
      ref={latestRef}
      className={[
        `${prefix}__message`,
        `${prefix}__message--${message.role}`,
        message.failed ? `${prefix}__message--failed` : null
      ].filter(Boolean).join(" ")}
    >
      <div className={`${prefix}__message-label`}>
        {message.role === "user" ? userLabel : "Obsero AI"}
        {message.failed ? (
          <i className="bi bi-exclamation-triangle-fill ms-1 text-danger" aria-label="Fejl" />
        ) : null}
      </div>
      <ChatbotMessageContent
        className={`${prefix}__message-body`}
        content={message.content}
        role={message.role}
      />
      <ChatbotFileList files={message.files || []} />
      {message.cancelled ? <div className="small text-secondary mt-2" role="status">Svaret blev stoppet.</div> : null}
      {message.role === "assistant" && message.references?.length > 0 ? (
        <ChatbotReferenceBubbles references={message.references} />
      ) : null}
    </article>
  );
}
